import Vue from 'vue';
import Component from 'vue-class-component';
import { initialize } from '@open-iframe-resizer/core';
@Component()
export default class WhatIsBBViewComponent extends Vue {
  mounted() {
    initialize({}, '#iframe-about');
  }
}
